import type { MouseEvent } from 'react'
import { GlyphIcon, type GlyphIconName } from '../components/GlyphIcon'
import { withBasePath } from '../routing/basePath'
import type { RouteId } from '../routing/routeTable'

interface BottomNavProps {
  activeRoute: RouteId
  communityPath: string
  onNavigate: (route: string) => void
}

const items: ReadonlyArray<{ href: string; ids: RouteId[]; label: string; icon: GlyphIconName }> = [
  { href: '/home', ids: ['home'], label: 'Home', icon: 'home' },
  { href: '/tour', ids: ['tour', 'show-detail', 'itinerary', 'check-in'], label: 'Tour', icon: 'tour' },
  { href: '/tickets', ids: ['tickets', 'ticket-connect', 'ticket-detail'], label: 'Tickets', icon: 'ticket' },
  { href: '', ids: ['feed'], label: 'Community', icon: 'chat' },
  { href: '/passport', ids: ['passport'], label: 'Passport', icon: 'passport' },
]

export function BottomNav({ activeRoute, communityPath, onNavigate }: BottomNavProps) {
  const handleClick = (event: MouseEvent<HTMLAnchorElement>, route: string) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
    event.preventDefault()
    onNavigate(route)
  }

  return (
    <nav aria-label="Primary" className="bottom-nav">
      {items.map((item) => {
        const active = item.ids.includes(activeRoute)
        const href = item.ids.includes('feed') ? communityPath : item.href
        return (
          <a
            aria-current={active ? 'page' : undefined}
            className="bottom-nav__item"
            href={withBasePath(href)}
            key={item.label}
            onClick={(event) => handleClick(event, href)}
          >
            <GlyphIcon className="bottom-nav__icon" name={item.icon} />
            <span>{item.label}</span>
          </a>
        )
      })}
    </nav>
  )
}
